// Side-effect module: imported FIRST by main.js so the storage fallback is in
// place before any other module (store, router, stores) touches localStorage.
// ES imports evaluate in order, so a call placed in main.js's body would run
// too late. See utils/storageFallback.js.
import { installStorageFallback } from '@/utils/storageFallback'

if (typeof window !== 'undefined') installStorageFallback(window)
